// Routes owned by the Documents module. Merged into the app-wide `paths` object
// by src/app/paths.ts; see src/modules/README.md.
export const documentsPaths = {
    documentList: '/documents',
    // Unreferenced: no paths.* caller; route is live (/documents/share).
    documentShare: '/documents/share',
    documentCreate: '/documents/new',
    documentUpdate: '/documents/:id/edit',
    documentApproved: '/documents/approved',
} as const
